import React from "react";
import UnstyledLink from "@pency/components/controls/Link";
import ArrowUpRightIcon from "@pency/components/icons/ArrowUpRight";
import {Stack, Text} from "@chakra-ui/core";

interface Props {
  href: string;
}

const Link: React.FC<Props> = ({children, href}) => {
  return (
    <UnstyledLink
      isExternal
      _first={{borderTopWidth: 1}}
      _hover={{color: "white", backgroundColor: "primary.500"}}
      borderBottomWidth={1}
      borderColor="gray.300"
      fontSize="lg"
      fontWeight={500}
      href={href}
      padding={6}
      width="100%"
    >
      <Stack isInline>
        <Text>{children}</Text>
        <ArrowUpRightIcon marginLeft="auto" opacity={0.5} />
      </Stack>
    </UnstyledLink>
  );
};

export default Link;
